import { IFacultativesWidgetData } from '.';
import { IAbstractRecord } from '@models';
import { compareStrings } from '@utils/helper-utils';
import { isEmpty } from '@utils/validationUtils';

export const mapToListingData = (data: IAbstractRecord[]) => {
  const list: Record<string, IFacultativesWidgetData> = {};

  if (isEmpty(data)) {
    return {};
  }

  /**
   * Facultative ID is compared first.
   *    If IDs differ, their order is decided by that comparison.
   *    If IDs are the same, then the policy is compared.
   *        If policies are also identical, the cover name comparison decides the order.
   */
  const sorted = [...data].sort((a, b) => {
    // 1) Compare FacID
    const facIdComparison = compareStrings(
      a.facultative_FacultativeID,
      b.facultative_FacultativeID
    );
    if (facIdComparison !== 0) return facIdComparison;

    // 2) Compare policy
    const policyComparison = compareStrings(
      a.policy_PolicyNumber,
      b.policy_PolicyNumber
    );
    return policyComparison;
  });

  sorted.forEach((item: IAbstractRecord, index: number) => {
    list[index] = {
      facultativeId: item.facultative_FacultativeID,
      slipRefNo: item.facultative_SlipReferenceNumber,
      policy: item.policy_PolicyNumber,
      dueDate: item.facultative_PaymentDueDate,
      cededPremium: Number(item.facultative_TotalCededPremium),
      commissionAmount: item.facultative_TotalCommission,
      amountDue: item.facBill_AmountDue,
      amountPaid: item.facBill_AmountPaid,
      facBillBalance: item.facBill_OutstandingBalance,
      Currency: item.facBill_Currency?.Symbol,
    };
  });

  return list;
};
